import { invisiblyApi } from "src/redux/api/invisibly-api";
import { InvisiblyApiResponse } from "src/types/apiResponses";
import { PanelScoutUser } from "../types/panel-scout-user.types";

export const panelScoutUsersEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getPanelScoutUsers: builder.query<PanelScoutUser[], void>({
      query: () => ({
        method: "GET",
        url: "panelscout/users",
      }),
      transformResponse(response: InvisiblyApiResponse<PanelScoutUser[]>) {
        const items = (response.item ?? []) as PanelScoutUser[];
        return items.map((u: PanelScoutUser) => ({
          ...u,
          id: u.id || u.ext_user_id || u.email,
        }));
      },
      providesTags: () => [],
    }),
  }),
});

export const { useGetPanelScoutUsersQuery } = panelScoutUsersEndpoints;
